import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

import IconHexagon from '@learningblocks/exp-constants/lib/Icons/hexagon-solid'
import { TakeAwayWidget } from '@learningblocks/storybook-components';

export class TakeawayMessages extends React.Component {
  render() {
    return(
      <div className={this.props.className}>
        <h5 tabIndex={0}>{this.props.heading}</h5>
          {this.props.items.map((item, index)=>{
            return(
              <div style={{marginTop: '15px'}}>
                <TakeAwayWidget 
                  image={item.image} 
                  alt=""
                  text={item.message}
                  />
              </div>
            )
          })}
      </div>
    )
  }
}
TakeawayMessages.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  items: PropTypes.array.isRequired,
  heading: PropTypes.string.isRequired,
  className: PropTypes.string,
};

TakeawayMessages.defaultProps = {
  className: 'takeawayMessages',
};
